module.exports = __webpack_public_path__ + "static/media/becomeAHostGreen.a2b5817b.svg";